'use client';

import {NavigationMenuLink, navigationMenuTriggerStyle} from '@/components/ui/navigation-menu';
import Link from 'next/link';
import {usePathname} from 'next/navigation';

interface NavigationItemProps {
  children: React.ReactNode;
  disabled?: boolean;
  href?: string;
  onClick?: () => void;
  variant?: 'main' | 'sidebar';
}

export default function NavigationItem({
  children,
  disabled = false,
  href = '',
  onClick,
  variant = 'main',
}: NavigationItemProps) {
  const pathname = usePathname();
  const isActive = pathname?.includes(href);

  function handleOnClick() {
    if (disabled) {
      return;
    }

    onClick?.();
  }

  return (
    <Link aria-disabled={disabled} href={href} legacyBehavior passHref>
      <NavigationMenuLink
        className={navigationMenuTriggerStyle(
          variant === 'sidebar'
            ? {
                className: 'flex-1 justify-start gap-4',
              }
            : undefined
        )}
        active={isActive}
        onClick={handleOnClick}
      >
        {children}
      </NavigationMenuLink>
    </Link>
  );
}
